import { render } from "./CodeMethodForm.vue?vue&type=template&id=480ecbb9&ts=true"
import script from "./CodeMethodForm.vue?vue&type=script&lang=ts"
export * from "./CodeMethodForm.vue?vue&type=script&lang=ts"

import "./CodeMethodForm.vue?vue&type=style&index=0&id=480ecbb9&lang=sass"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__